import { ChildrenItem } from "dependencies/base"
import { Countdown } from "./model"
import { home, bs, appHome } from "./diffrence_options"
let icon = "icon-portal_countdown"
export let countdown_children = []
export let bigScreen_countdown_children = []
export let app_countdown_children = []
let cover = [
  require("assets/images/leftMenu/countdown/style1.png"),
]
for (let i = 0; i < home.length; i++) {
  countdown_children.push(new ChildrenItem("倒计时", icon, "cxCountdown", new Countdown(home[i]), cover[i]))
}
for (let i = 0; i < bs.length; i++) {
  bigScreen_countdown_children.push(new ChildrenItem("倒计时", icon, "cxCountdown", new Countdown(bs[i])))
}
for (let i = 0; i < appHome.length; i++) {
  app_countdown_children.push(new ChildrenItem("倒计时", icon, "cxCountdown", new Countdown(appHome[i]), cover[i]))
}
